<template>
  <div
    class="question-details border-thick border-primary border-top pr-2 pl-1 py-1"
    style="background-color: var(--v-subdued-base) !important"
  >
    <div class="pa-4">
      <v-icon color="primary">{{ mdiInformationOutline }}</v-icon>
      <span>
        <strong
          >This item is a response to a research question in
          {{ communityName }}</strong
        >
      </span>
      <div class="mt-4 primary--text">Q. {{ questionName }}</div>
      <div class="mt-4">
        <a :href="questionCoreUrl" target="_blank">
          <div class="question-details__link-text">
            Explore
            <span aria-hidden="true">this question</span>
            <span class="d-sr-only">{{ questionName }}</span>
            in full on Cambridge Core
          </div>
          <span class="d-sr-only">[opens in a new tab]</span>
          <v-icon small color="primary" aria-hidden="true">{{
            mdiOpenInNew
          }}</v-icon>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiInformationOutline, mdiOpenInNew } from "@mdi/js";

export default {
  name: "QuestionDetails",
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      // Icon
      mdiInformationOutline,
      mdiOpenInNew,
    };
  },
  computed: {
    questionName() {
      return this.article.question.name;
    },
    questionCoreUrl() {
      return this.article.question.coreUrl;
    },
    communityName() {
      return this.article.community.name;
    },
  },
};
</script>

<style lang="scss">
.question-details {
  &__link-text {
    display: inline;
  }
}
</style>
